module.exports = __webpack_public_path__ + "img/lens-160-plus-08.181f0b57.png";